<template>
  <div>
    <div class="trailer" :class="trailerClasses">
      <div class="tertiary" :class="topLevelClasses(terciary)" :key="'terciary-' + terciaryIdx" v-for="(terciary, terciaryIdx) in root.components">
        <ShippingLvlHeader :parent="root" :idx="terciaryIdx" :readOnly="readOnly" :showCarbon="showCarbon" :level="topLevel" />
        <div class="secondary" :class="secondTopLevelClasses" :key="'secondary-' + secondaryIdx" v-for="(secondary, secondaryIdx) in terciary.components">
          <ShippingLvlHeader :parent="terciary" :idx="secondaryIdx" :readOnly="readOnly" :showCarbon="showCarbon" :level="secondTopLevel" />
          <div class="primary primary-color" :key="'primary-' + primaryIdx" v-for="(primary, primaryIdx) in secondary.components">
            <ShippingLvlHeader :parent="secondary" :idx="primaryIdx" :readOnly="readOnly" :showCarbon="showCarbon" :level=1 />
          </div>
          <ShippingLvlAddButton v-if="!twolevels && !readOnly" :component="secondary" :level=1 />
        </div>
        <ShippingLvlAddButton v-if="!readOnly" :component="terciary" :level="secondTopLevel" />
      </div>
      <ShippingLvlAddButton v-if="!readOnly" :component="root" :level="topLevel" />
    </div>
    <v-shipping-lvl-modal v-if="!readOnly && !externalModal"/>
  </div>
</template>

<script>
import ShippingLvlModal from "./ShippingLvlModal";
import ShippingLvlHeader from "./ShippingLvlHeader";
import ShippingLvlAddButton from "./ShippingLvlAddButton";
import { isOverweight, isOverweightDeep } from "./shippingLvlUtils";

export default {
  name: 'ShippingLvls',
  props: ['root', 'twolevels', 'readOnly', 'showCarbon', 'externalModal'],
  components: {
    'v-shipping-lvl-modal': ShippingLvlModal,
    ShippingLvlHeader,
    ShippingLvlAddButton
  },
  computed: {
    trailerClasses() {
      const overweight = !this.readOnly && isOverweight(this.root);
      this.root.hasOverweightLvl = isOverweightDeep(this.root);
      this.$emit('change');
      return {
        'trailer-color': !overweight,
        'trailer-error': overweight
      }
    },
    secondTopLevelClasses() {
      return {
        'secondary-color': !this.twolevels,
        'primary-color': this.twolevels
      }
    },
    topLevel() {
      return this.twolevels ? 2 : 3;
    },
    secondTopLevel() {
      return this.twolevels ? 1 : 2;
    }
  },
  methods: {
    topLevelClasses(component) {
      const overweight = !this.readOnly && isOverweight(component);
      return {
        'tertiary-color': !overweight && !this.twolevels,
        'secondary-color': !overweight && this.twolevels,
        'tertiary-error': overweight
      }
    }
  }
}
</script>

<style>
.trailer, .tertiary, .secondary, .primary {
  margin: 10px;
  border-radius: 5px;
  padding: 10px;
  color: white;
  font-size: 20px;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 2;
  align-content: stretch; 
}

.trailer .header {
  display: block;
  width: 100%; 
}
.trailer .add {
  display: flex;
  margin: 10px 10px 10px 0; 
}
.trailer a {
  cursor: pointer;
}

.trailer .add .btn {
  margin: 0; 
}

.trailer-color {
  background-color: #000; 
}

.tertiary-color {
  background-color: #333; 
}

.secondary-color {
  background-color: #666; 
}

.primary-color {
  background-color: #999; 
}

.trailer-error {
  background-color: #B00020;
}

.tertiary-error {
  background-color: #d10026;
}
</style>


// WEBPACK FOOTER //
// ShippingLvls.vue?ed358024